<template>
  <div class="container container_bio">
    <div class="bio">
      <h2 class="bio__header">Hi 👋</h2>
      <p class="bio__name">I'm Daniil,</p>
      <p class="bio__info">
        I have experience in creating websites, landing pages, and developing
        basic logic of client interfaces, and currently looking for a job as a
        <span class="highlight">Junior Frontend Developer</span>.
      </p>
      <p class="bio__portfolio">
        🔗
        <router-link to="/projects" class="bio__link">
          Here are some projects I've worked on
        </router-link>
      </p>
      <p class="bio__contacts">
        If you'd like to have me as a junior member of your team, please contact
        me on
        <a class="bio__link" href="https://www.t.me/dniils" target="_blank"
          >Telegram</a
        >.
      </p>
    </div>
  </div>
</template>
